import { render } from "./IconSelector.vue?vue&type=template&id=7f6a330d&ts=true"
import script from "./IconSelector.vue?vue&type=script&lang=ts"
export * from "./IconSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__